import { render, staticRenderFns } from "./seriesBasicas.vue?vue&type=template&id=81bc9aa8"
import script from "./seriesBasicas.vue?vue&type=script&lang=js"
export * from "./seriesBasicas.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports